export const parseJwt = (token) => {
	if (!token) return null
	const base64Url = token.split('.')[1]
	const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
	const jsonPayload = decodeURIComponent(atob(base64).split('').map(c => {
		return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
	}).join(''))

	return JSON.parse(jsonPayload)
}

export const jwtExpired = (token) => {
	let jwt = parseJwt(token)
	let exp = jwt.exp
	return !exp || ((new Date(exp * 1000)) < new Date())
}

export const jwtContainsAnyRole = (token, roles) => {
	const jwt = parseJwt(token)
	if (!jwt) return false
	return roles.some(r => jwt.roles.includes(r))
}

export const jwtContainsAllRoles = (token, roles) => {
	const jwt = parseJwt(token)
	if (!jwt) return false
	return roles.every(r => jwt.roles.includes(r))
}

export const jwtContainsAnyGroup = (token, groups) => {
	const jwt = parseJwt(token)
	if (!jwt) return false
	return groups.some(g => jwt.group === g)
}

export const jwtGetCompanyData = (token) => {
	const jwt = parseJwt(token)
	if (!jwt) return false
	return jwt?.companyData
}

export const jwtGetUsername = (token) => {
	const jwt = parseJwt(token)
	if (!jwt) return false
	return jwt?.preferred_username
}

export const jwtGetRoles = (token) => {
	const jwt = parseJwt(token)
	if (!jwt) return false
	return jwt?.roles
}

export const jwtGetGroup = (token) => {
	const jwt = parseJwt(token)
	if (!jwt) return false
	return jwt?.group
}

export const jwtGetGroupId = (token) => {
	const jwt = parseJwt(token)
	if (!jwt) return false
	return jwt?.groupId
}
